import React from 'react';
import './StoreProductCard.css';
import './StoreProductCardLinkSkeleton.css';

interface StoreProductCardLinkSkeletonProps {
  isMobileView?: boolean;
  designTokens?: {
    tertiaryColor?: string;
    secondaryColor?: string;
    primaryColor?: string;
    forthColor?: string;
    templateName?: string;
  };
}

/**
 * Public-page Link View loading skeleton — matches StoreProductCard link layout.
 * Themed pages: card fill = forthColor/surface (same as live cards). Do not use
 * primaryColor/bg — that matches the page and leaves empty outlined boxes on
 * Website LiB / design-option frontends.
 */
const StoreProductCardLinkSkeleton: React.FC<StoreProductCardLinkSkeletonProps> = ({
  isMobileView = false,
  designTokens,
}) => {
  const templateName = String(designTokens?.templateName || '').toLowerCase();
  const isDefaultTheme = templateName === 'default' || !templateName;
  // Surface (forth), not page bg (primary) — Elements Guide / live product cards.
  const fillColor = isDefaultTheme
    ? undefined
    : designTokens?.forthColor || designTokens?.primaryColor;
  const inkColor = isDefaultTheme
    ? undefined
    : designTokens?.secondaryColor || designTokens?.tertiaryColor || '#16161a';
  const borderColor = isDefaultTheme
    ? '#e6e7eb'
    : designTokens?.tertiaryColor ||
      designTokens?.secondaryColor ||
      '#e6e7eb';

  return (
    <div
      className={`store-product-card store-product-card--link store-product-card--skeleton${
        isMobileView ? ' store-product-card--mobile' : ''
      }${isDefaultTheme ? '' : ' store-product-card--skeleton-themed'}`}
      style={{
        borderColor,
        backgroundColor: isDefaultTheme ? '#fff' : fillColor || '#fff',
        ...(inkColor
          ? ({
              // Soft ink wash — same idea as `.mte-tpl-skel-fill` (ink ~11%).
              ['--store-skel-bone' as string]: `color-mix(in srgb, ${inkColor} 14%, ${
                fillColor || '#fff'
              })`,
              ['--store-skel-bone-hi' as string]: `color-mix(in srgb, ${inkColor} 8%, ${
                fillColor || '#fff'
              })`,
            } as React.CSSProperties)
          : {}),
      }}
      aria-hidden="true"
    >
      <div className="store-product-card__left store-product-card__highlight-layout store-product-card-skel__left">
        <div className="store-product-card-skel store-product-card-skel--thumb" />
        <div className="store-product-card__details store-product-card-skel__details">
          <div className="store-product-card-skel store-product-card-skel--title" />
          <div className="store-product-card-skel store-product-card-skel--subtitle" />
        </div>
      </div>
      <div className="store-product-card__right store-product-card-skel__right">
        <div className="store-product-card-skel store-product-card-skel--btn" />
      </div>
    </div>
  );
};

export default StoreProductCardLinkSkeleton;
